import useUserPreference from './useUserPreference';

// Modo de vista por defecto según dispositivo: tabla en escritorio, tarjetas en
// móvil (directriz global de listados). Solo se aplica la PRIMERA vez, cuando el
// usuario aún no ha elegido modo para esa pantalla; a partir de ahí manda la
// preferencia guardada (BD por usuario + navegador + pantalla).
export const getDefaultViewMode = () => {
  try {
    if (typeof window !== 'undefined' && window.matchMedia
      && window.matchMedia('(max-width: 768px)').matches) {
      return 'cards';
    }
  } catch { /* matchMedia no disponible: cae a tabla */ }
  return 'table';
};

// Recuerda el modo ('table' | 'cards') con el mismo mecanismo que los filtros
// (useUserPreference → tabla user_filter_prefs). `scope` es el ámbito único de
// la pantalla, p. ej. 'customers' → clave 'customers:viewMode'.
const useViewMode = (scope) => useUserPreference(`${scope}:viewMode`, getDefaultViewMode());

export default useViewMode;
